import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    projId = '',
    level = '1',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projKpiAudit.flowRead, {
        projId,
        level: Number.parseInt(level),
    }, options);
    if (error) return { error, status };
    return content || { };
};
